import {
	SoccerPerformanceCategory,
	SOCCER_PERFORMANCE_CATEGORY_LABELS,
} from './soccer-performance-category.enum';
import {
	TennisPerformanceCategory,
	TENNIS_PERFORMANCE_CATEGORY_LABELS,
} from './tennis-performance-category.enum';
import {
	FootballPerformanceCategory,
	FOOTBALL_PERFORMANCE_CATEGORY_LABELS,
} from './football-performance-category.enum';

/**
 * The performance category a settled forecast is filed under on the results screen.
 *
 * Each sport contributes its own vocabulary; this union is what crosses the wire and
 * what the client renders. Use getPerformanceCategoriesForSport (performance-category
 * config) to get the set that applies to a given event.
 */
export type PerformanceCategory =
	| SoccerPerformanceCategory
	| TennisPerformanceCategory
	| FootballPerformanceCategory;

export const PERFORMANCE_CATEGORY_LABELS: Record<PerformanceCategory, string> = {
	...SOCCER_PERFORMANCE_CATEGORY_LABELS,
	...TENNIS_PERFORMANCE_CATEGORY_LABELS,
	...FOOTBALL_PERFORMANCE_CATEGORY_LABELS,
};

export function getPerformanceCategoryLabel(category: string | null | undefined): string | null {
	if (!category) return null;
	return PERFORMANCE_CATEGORY_LABELS[category as PerformanceCategory] ?? category;
}
